class TriageQuestion {
  constructor(title, tag, cheifComplaintId) {
    this.title = title;
    this.tag = tag;
    this.cheifComplaintId = cheifComplaintId;
  }
}
export default {
  inject: ['load'],
  data() {
    return {
      confimType: '',
      triageQuestionId: null,
      searchTitle: '',
      disabelConfirm: false,
      addFlag: false,
      modalTitle: '',
      showAddEditModal: false,
      modalIcon: '',
      currentQuestionId: null,
      previousAnswerId: null,
      myIsRoot: true,
      siteMapItems: [],
      siteMap: false,
    };
  },
  methods: {
    enableAddEditFunction: function (type, id) {
      if (type == 1) {
        if (this.triageQuestions) {
          this.snackText = 'امکان افزودن سوال جدید وجود ندارد.';
          this.$refs.snackRef.snackModel = true;
          this.snackColor = '#FF5252';
          this.snakIcon = 'mdi-information';
          this.disabelConfirm = false;
          return;
        }
        this.modalTitle = 'افزودن سوال';
        this.modalIcon = 'mdi-plus';
        this.addFlag = true;
        this.confimType = 'add';
        this.showAddEditModal = true;
      } else if (type == 2) {
        this.modalTitle = 'ویرایش سوال';
        this.modalIcon = 'mdi-pencil';
        this.confimType = 'edit';
        this.addFlag = false;
        this.getTriageQuestionFunction(id);
        this.showAddEditModal = true;
      }
    },
    cancelAddEditFunction: function () {
      this.triageQuestion = new TriageQuestion('', '', null);
      this.showAddEditModal = false;
    },
    showConfirmDialogFunction: function () {
      if (this.confimType == 'add') {
        if (this.myIsRoot == true) {
          this.addTriageQuestionRootFunction();
        } else {
          this.addTriageQuestionFunction();
        }
      } else if (this.confimType == 'edit') {
        this.$refs.confirm.title = 'ویرایش سوال';
        this.$refs.confirm.text = 'از ویرایش سوال اطمینان دارید؟';
        this.$refs.confirm.showConfirmDialog = true;
      } else if (this.confimType == 'delete') {
        this.$refs.confirm.title = 'حذف سوال';
        this.$refs.confirm.text = 'از حذف سوال اطمینان دارید؟';
        this.$refs.confirm.showConfirmDialog = true;
      }
      requestAnimationFrame(() => {
        if (this.$refs.yes) {
          this.$refs.yes.$el.focus();
        }
      });
    },
    confirmDialogConfirmFunction: function () {
      if (this.confimType == 'add') {
        this.disabelConfirm = true;
        if (this.myIsRoot == true) {
          this.addTriageQuestionRootFunction();
        } else {
          this.addTriageQuestionFunction();
        }
      } else if (this.confimType == 'edit') {
        this.disabelConfirm = true;
        this.editTriageQuestionFunction();
      } else if (this.confimType == 'delete') {
        this.disabelConfirm = true;
        this.deleteTriageQuestionFunction();
      }
    },
    confirmDialogCancelFunction: function () {
      if (this.confimType == 'add') {
        this.$refs.confirm.showConfirmDialog = false;
        this.disabelConfirm = false;
      } else if (this.confimType == 'edit') {
        this.$refs.confirm.showConfirmDialog = false;
        this.disabelConfirm = false;
      } else if (this.confimType == 'delete') {
        this.$refs.confirm.showConfirmDialog = false;
        this.disabelConfirm = false;
      }
    },
    //delete
    showDeleteConfirmFunction: function (id) {
      this.triageQuestionId = id;
      this.confimType = 'delete';
      this.showConfirmDialogFunction();
    },
    goToTriageAnswerPage: function (data) {
      this.generateSiteMap(data, 'sss');
      localStorage.setItem('qTitle', data.title);
      let path = '';
      if (this.$route.params.id) {
        let tempPath = localStorage.getItem('path');
        if (tempPath) {
          tempPath += '-' + this.$route.params.id;
        }
        path = tempPath;
      } else {
        let tempPath = 'root';
        path = tempPath;
      }
      localStorage.setItem('path', path);
      let id = data.id;
      this.$router.push({ name: 'triageAnswer', params: { id: id } });
    },
    backToAnswerPage: function () {
      this.removeLastPath();
      if (this.myIsRoot == true) {
        this.$router.push({ name: 'chiefComplaint' });
        return;
      }
      let tempPath = localStorage.getItem('path');
      let path = tempPath.split('-');
      let info = path[path.length - 1];
      let mypath = '';
      for (let i = 0; i < path.length - 1; i++) {
        mypath += path[i] + '-';
      }
      mypath = this.removeLastCharechter(mypath);
      localStorage.setItem('path', mypath);
      this.$router.push({ name: 'triageAnswer', params: { id: info } });
    },
    removeLastPath: function () {
      let map = localStorage.getItem('qSiteMap');
      if (map) {
        if (map.includes('_')) {
          let path = map.split('_');
          for (let i = 0; i < path.length; i++) {
            if (path[i] == '') {
              path.splice(i, 1);
            }
          }
          if (path.length > 1) {
            let allPath = '';
            for (let i = 0; i < path.length - 1; i++) {
              let info = path[i] + '_';
              allPath += info;
            }
            localStorage.setItem('qSiteMap', allPath);
          } else {
            localStorage.removeItem('qSiteMap');
          }
        }
      }
    },
    generateSiteMap: function (data, selectedItem) {
      if (this.myIsRoot) {
        let info = 'qt-' + 'noId' + '-';
        info += data.title + '-' + data.id + '_';
        localStorage.setItem('qSiteMap', info);
      } else {
        let map = localStorage.getItem('qSiteMap');
        let path = map.split('_');
        if (map.includes(selectedItem)) {
          console.log(selectedItem);
        } else {
          let info = 'qt-' + this.$route.params.id + '-' + data.title + '-' + path.length + 1 + '_';
          let pathInfo = map + info;
          localStorage.setItem('qSiteMap', pathInfo);
        }
      }
    },
    showSiteMap: function () {
      this.siteMap = true;
      this.siteMapItems = [];
      let map = localStorage.getItem('qSiteMap');
      let path = map.split('_');
      for (let i = 0; i < path.length; i++) {
        if (path[i] == '') {
          path.splice(i, 1);
        }
      }
      for (let i = 0; i < path.length; i++) {
        let pathInfo = path[i].split('-');
        this.siteMapItems.push({
          title: pathInfo[2],
          type: pathInfo[0],
          urlId: pathInfo[1],
          id: pathInfo[3],
        });
      }
    },
    closeSiteMap: function () {
      this.siteMapItems = [];
      this.siteMap = false;
    },
    goToSiteMapItem: function (data) {
      let map = localStorage.getItem('qSiteMap');
      let path = map.split('_');
      for (let i = 0; i < path.length; i++) {
        if (path[i] == '') {
          path.splice(i, 1);
        }
      }
      let allInfo = '';
      let counter = 0;
      for (let i = 0; i < path.length; i++) {
        let pathInfo = path[i].split('-');
        let temp = {
          title: pathInfo[2],
          type: pathInfo[0],
          urlId: pathInfo[1],
          id: pathInfo[3],
        };
        if (temp.id != data.id) {
          let rouet = temp.type + '-' + temp.urlId + '-' + temp.title + '-' + i + 1 + '_';
          allInfo += rouet;
          counter++;
        } else {
          if (data.type == 'a') {
            localStorage.setItem('qSiteMap', allInfo);
            let tempPath = localStorage.getItem('path');
            let tempPathSplited = tempPath.split('-');
            //counter++;
            let backRouteIds = '';
            /*for (let j = 0; j < tempPathSplited.length - counter; j++) {
                            backRouteIds += tempPathSplited[j] + "-";
                        }*/
            for (let j = 0; j < counter; j++) {
              backRouteIds += tempPathSplited[j] + '-';
            }
            backRouteIds = this.removeLastCharechter(backRouteIds);
            localStorage.setItem('path', backRouteIds);
            let flag = false;
            if (this.$route.name == 'triageAnswer') {
              flag = true;
            }
            this.$router.push({
              name: 'triageAnswer',
              params: { id: data.urlId },
            });
            if (flag) {
              window.location.reload();
            }
          } else if (data.type == 'q') {
            if (data.urlId == 'noId') {
              localStorage.setItem('qSiteMap', '');
              localStorage.setItem('path', '');
              let flag = false;
              if (this.$route.name == 'generalTriageQuestion') {
                flag = true;
              }
              this.$router.push({ name: 'generalTriageQuestion' });
              if (flag) {
                window.location.reload();
              }
            } else {
              localStorage.setItem('qSiteMap', allInfo);
              let tempPath = localStorage.getItem('path');
              let tempPathSplited = tempPath.split('-');
              //counter++;
              let backRouteIds = '';
              /*for (let j = 0; j < tempPathSplited.length - counter; j++) {
                                backRouteIds += tempPathSplited[j] + "-";
                            }*/
              for (let j = 0; j < counter; j++) {
                backRouteIds += tempPathSplited[j] + '-';
              }
              backRouteIds = this.removeLastCharechter(backRouteIds);
              localStorage.setItem('path', backRouteIds);
              let flag = false;
              if (this.$route.name == 'generalTriageQuestion') {
                flag = true;
              }
              this.$router.push({
                name: 'generalTriageQuestion',
                params: { id: data.urlId },
              });
              if (flag) {
                window.location.reload();
              }
            }
          } else if (data.type == 'qt') {
            if (data.urlId == 'noId') {
              localStorage.setItem('qSiteMap', '');
              localStorage.setItem('path', '');
              let flag = false;
              if (this.$route.name == 'triageQuestion') {
                flag = true;
              }
              this.$router.push({ name: 'triageQuestion' });
              if (flag) {
                window.location.reload();
              }
            } else {
              localStorage.setItem('qSiteMap', allInfo);
              let tempPath = localStorage.getItem('path');
              let tempPathSplited = tempPath.split('-');
              //counter++;
              let backRouteIds = '';
              /* for (let j = 0; j < tempPathSplited.length - counter; j++) {
                                backRouteIds += tempPathSplited[j] + "-";
                            }*/
              for (let j = 0; j < counter; j++) {
                backRouteIds += tempPathSplited[j] + '-';
              }
              backRouteIds = this.removeLastCharechter(backRouteIds);
              localStorage.setItem('path', backRouteIds);
              let flag = false;
              if (this.$route.name == 'triageQuestion') {
                flag = true;
              }
              this.$router.push({
                name: 'triageQuestion',
                params: { id: data.urlId },
              });
              if (flag) {
                window.location.reload();
              }
            }
          }
        }
      }
    },
  },
};
